<div class="mx-auto mt-32 max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
  <div class="mx-auto max-w-3xl text-center">
    <h1 class="mb-8 font-cirka text-4xl font-bold text-white">Notices</h1>

    <p class="text-justify text-gray-300">
      TradingView Lightweight Charts™ Copyright (с) 2025 TradingView, Inc. <a href="https://www.tradingview.com/"
        >https://www.tradingview.com/</a
      >
    </p>
  </div>
</div>
